import type { DokladyDokladDto, DokumentyDokumentDto } from '@gov-nx/api';
import type { GovError } from '@gov-nx/core/app';
import type { ProcessControlCore } from '@gov-nx/core/hooks';
import type { Nullable } from '@gov-nx/core/types';
import type { useDocumentPreview } from './useDocumentPreview';

export enum DokladyType {
	/** Obcansky prukaz */
	ID = 'ID',
	/** Pas */
	P = 'P',
	/** Ridicsky prukaz */
	RP = 'RP',
}

export interface IdentityDocumentControls extends ProcessControlCore {
	displayComplaintModal: DokladyDokladDto;
}

export interface IdentityDocumentsContext {
	documents: DokladyDokladDto[];
	isDocumentsLoading: boolean;
	documentsError?: GovError;

	driversLicense?: DokladyDokladDto;
	canChangeLicence: boolean;
	zadostNovyRidicskyPrukazUrl: Nullable<string>;
	hasLicense: boolean;
	isDriversLicenseLoading: boolean;
	driversLicenseError?: GovError;

	ownDocuments: DokumentyDokumentDto[];
	ownDocumentsError?: GovError;

	controls: IdentityDocumentControls;
	setControls: (control: Partial<IdentityDocumentControls>) => void;
	getDocumentByType: (type: DokladyType) => DokladyDokladDto[];
	isDocumentLoadingByType: (type: DokladyType) => boolean;
	onOwnDocumentDelete: ({
		id,
		permanent,
	}: {
		id: number;
		permanent: boolean;
	}) => void;
	documentPreviewQuery: ReturnType<typeof useDocumentPreview>;
}
